document.addEventListener('DOMContentLoaded', () => {
  (customElements.get('predictive-search')
    ? Promise.resolve()
    : customElements.whenDefined('predictive-search')
  ).then(() => {
    document.querySelectorAll('predictive-search').forEach(ps => {
      const input   = ps.querySelector('input[type="search"]');
      const results = ps.querySelector('#predictive-search');
      if (!input || !results) return;

      // Klick außerhalb schließt Panel
      document.addEventListener('click', e => {
        if (results.style.display === 'block' && !ps.contains(e.target)) {
          results.style.display = 'none';
        }
      });

      // Eingabe, Fokus, Attributwechsel: Panel sofort richtig ausrichten & Scroll-Refresh triggern
      function triggerPositionAndScrollFix() {
        setTimeout(() => {
          alignBelowHeader(results);
          window.scrollBy(0, 0.0001); // Mini-Scroll erzwingt Scroll-Listener-Update
        }, 0);
      }
      input.addEventListener('input', triggerPositionAndScrollFix);
      input.addEventListener('focus', triggerPositionAndScrollFix);

      // Panel bei Scroll & Resize neu positionieren
      window.addEventListener('scroll', () => {
        if (ps.hasAttribute('open')) alignBelowHeader(results);
      });
      window.addEventListener('resize', () => {
        if (ps.hasAttribute('open')) alignBelowHeader(results);
      });

      // Panel auch beim Öffnen des "open"-Attributs korrekt positionieren
      const observer = new MutationObserver(() => {
        if (ps.hasAttribute('open')) {
          triggerPositionAndScrollFix();
        }
      });
      observer.observe(ps, { attributes: true });
    });
  });
});

function alignBelowHeader(resultsEl) {
  const ps = resultsEl.closest('predictive-search');
  if (!ps) return;
  const header = document.getElementById('SiteHeader');
  if (!header) return;
  const headerBottomPx = header.getBoundingClientRect().bottom;
  const psRect = ps.getBoundingClientRect();

  // 1. Panel ins document.body hängen (nur wenn noch nicht dort!)
  if (resultsEl.parentNode !== document.body) {
    document.body.appendChild(resultsEl);
  }

  // 2. Exakte Positionierung
  Object.assign(resultsEl.style, {
    position:  'fixed',
    top:       `${headerBottomPx}px`,
    left:      `${psRect.left}px`,
    width:     `${psRect.width}px`,
    marginTop: '0',
    zIndex:    '2147483647',
    background:'#fff'
  });
}